<template>
  <!--- Sidemenu -->
  <div class="nav-list-menu" id="sidebar-menu">
    <ul class="list-nav accordion" v-if="getMenu.length > 0" id="accordionSidebar">
      <li class="content-3">
        <router-link
          class="nav-link-menu nav-item-home d-flex align-items-center"
          :to="{ path: getMenu[0].path }"
        >
          Página Principal
        </router-link>
      </li>
      <hr class="sidebar-divider-1" />
      <li
        class="content-3"
        v-for="(entry, index) in getMenu.slice(1, getMenu.length)" 
        :key="index"
      >
        <a
          class="nav-link-menu collapsed d-flex justify-content-between align-items-center"
          @click.prevent="togglecollapse(index)"
        >
          {{ entry.name }}
          <span class="">
            <span
              v-if="entry.children.length > 0"
              class="menu-arrow"
            />
          </span>
        </a>
        <b-collapse :id="'collapse' + index" accordion="my-accordion" role="tabpanel">
          <div class="nav-list-menu d-flex flex-column bg-white py-2">
            <router-link
              class="nav-link-menu"
              v-for="item of entry.children"
              :key="item.id"
              :to="{ path: item.path }"
              >
                {{ item.name }}
              </router-link>
          </div>
        </b-collapse>
        <hr class="sidebar-divider-1" />
      </li>
    </ul>
  </div>
  <!-- End Sidebar -->
</template>
<script>
import { authComputed, authMethods } from '@state/helpers'

export default {
  components: {},
  props: {
    isCondensed: {
      type: Boolean,
      required: false,
    },
    toggleMenu: {
      type: Function,
      required: false,
      default: () => { },
    },
  },
  computed: {
    ...authComputed,
    getMenu: function () {
      return this.$store.state.auth.currentSession
        ? this.$store.state.auth.currentSession.user.app_sections_tree
        : []
    },
  },
  created: function () {
    if (this.loggedIn) {
      this.setUserActiveSection(this.$route.path)
    }
  },
  methods: {
    ...authMethods,
    togglecollapse(index) {
      const me = this;
      me.$root.$emit('bv::toggle::collapse', 'collapse' + index)
    }
  },
}
</script>


<style lang="scss">
.nav-list-menu {
  display: none;
}
.list-nav {
  list-style: none !important;
  margin: 0 !important;
  padding-left: 0 !important;
}
.nav-list-menu ul li {
  list-style: none;
  -webkit-transition:all 0.2s linear;
  -moz-transition:all 0.2s linear;
  -o-transition:all 0.2s linear;
  transition:all 0.2s linear;
  cursor: pointer;
}

.nav-link-menu {
  font-size: 12px !important;
  font-family: 'Montserrat', sans-serif;
  color: #222222;
  padding: 13px 20px 12px 30px !important;
  text-decoration: none !important;
}

.nav-item-home {
  padding-top: 15px !important;
}

.nav-link-menu.router-link-active {
  color: #245E8E !important;
  font-weight: 600 !important;
}

.nav-link-menu:hover {
  background-color: #c3d6e6 !important;
  color: #fff!important;
}

/*** VERSION CELULAR ***/
@media only screen and (max-width: 767px)
{
  .nav-list-menu {
    display: block;
  }
}

</style>
